export default __webpack_public_path__ + "static/media/magnifier-search-filter.bdd5acb5.svg";